var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-title-group" },
        [
          _c("h1", [_vm._v("Network Sites")]),
          _c(
            "el-button",
            {
              attrs: { type: "accent", icon: "el-icon-plus" },
              on: { click: _vm.openAddEditDialog }
            },
            [_vm._v(" Create New Site ")]
          )
        ],
        1
      ),
      _c(
        "FilterPanel",
        [
          _c("NetworkSitesFilters", {
            on: { filter: _vm.doFilter, export: _vm.doExport }
          })
        ],
        1
      ),
      _c(
        "MainPanel",
        [
          _c(
            "div",
            { staticClass: "action-bar" },
            [
              _c("PageLimitSwitcher", {
                attrs: { active: _vm.filterObject.per_page },
                on: { click: _vm.setPageLimit }
              }),
              _vm.networkSites
                ? _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      "page-size": _vm.filterObject.per_page,
                      "current-page": _vm.filterObject.page,
                      total: _vm.networkSites.total,
                      "hide-on-single-page": ""
                    },
                    on: { "current-change": _vm.changePage }
                  })
                : _vm._e(),
              _c("div", { staticClass: "table-total" }, [
                _vm._v(
                  " Total Items: " +
                    _vm._s(
                      (_vm.networkSites && _vm.networkSites.total) || "-"
                    ) +
                    " "
                )
              ])
            ],
            1
          ),
          _c("NetworkSitesList", {
            attrs: { loading: _vm.loading },
            on: {
              sort: _vm.doSort,
              edit: _vm.openAddEditDialog,
              "show-logs": _vm.openLogsDialog,
              "show-links": _vm.openLinksDialog,
              "refetch-data": _vm.getNetworkSites
            }
          })
        ],
        1
      ),
      _c("AddEditSiteDialog", {
        attrs: { visible: _vm.addEditDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.addEditDialogVisible = $event
          },
          close: _vm.closeAddEditDialog,
          "refetch-data": _vm.getNetworkSites
        }
      }),
      _c("SiteLogsDialog", {
        attrs: { visible: _vm.logsDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.logsDialogVisible = $event
          },
          close: _vm.closeLogsDialog
        }
      }),
      _c("LinksDialog", {
        attrs: { visible: _vm.linksDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.linksDialogVisible = $event
          },
          close: _vm.closeLinksDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }